import React, { CSSProperties } from 'react';
import styles from './BodyText.module.scss';
import { withStyles } from '../../../utils/utils';

const cn = withStyles(styles);

export type BodyTextProps = {
  size?: 'rg' | 'sm';
  weight?: 'rg' | 'md' | 'em';

  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  /** `span` for text inside a sentence (e.g. a link's label), where a block `div` cannot sit. */
  as?: 'div' | 'span';
};

const BodyText: React.FC<BodyTextProps> = ({
  size = 'rg',
  weight = 'rg',
  as: Element = 'div',
  children,
  className,
  ...props
}) => {
  return (
    <Element className={cn('bodyTextContainer', `size-${size}`, `emphasis-${weight}`, className)} {...props}>
      {children}
    </Element>
  );
};

export default BodyText;
